import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@core/modules/translation';

@Pipe({
	standalone: true,
	name: 'duration',
	pure: false,
})
export class DurationPipe implements PipeTransform {
	constructor(private translator: TranslateService) {}

	transform(seconds?: number | null, format: 'short' | 'long' | 'minutes' = 'short'): string {
		if (!seconds || seconds === Infinity) return '--';
		if (seconds < 1) return '';

		if (format === 'minutes') {
			if (seconds < 60) return `${Math.round(seconds)}s`;
			const mins = Math.floor(seconds / 60);
			return `${mins} min`;
		}

		const units = [
			{
				short: 'day',
				singular: 'UTILS.DURATIONS.DAY',
				plural: 'UTILS.DURATIONS.DAYS',
				value: 86400,
			},
			{
				short: 'h',
				singular: 'UTILS.DURATIONS.HOUR',
				plural: 'UTILS.DURATIONS.HOURS',
				value: 3600,
			},
			{
				short: 'min',
				singular: 'UTILS.DURATIONS.MINUTE',
				plural: 'UTILS.DURATIONS.MINUTES',
				value: 60,
			},
			{
				short: 'sec',
				singular: 'UTILS.DURATIONS.SECOND',
				plural: 'UTILS.DURATIONS.SECONDS',
				value: 1,
			},
		];

		let remaining = seconds;
		const parts: string[] = [];

		for (const unit of units) {
			const amount = Math.floor(remaining / unit.value);
			remaining %= unit.value;
			if (amount > 0) {
				const label =
					unit.short === 'day' || format === 'long'
						? this.translator.translate(
								amount > 1 ? unit.plural : unit.singular
							)
						: unit.short;
				parts.push(`${amount} ${label}`);
			}
			// Stop at hours if we already have days
			if (unit.value === 3600 && parts.length > 1) break;
		}

		return parts.join(' ');
	}
}
